import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  tokenExpiryInMS: 0,
  idpUrl: '',
  token: null,
  crossTenantSession: false,
  isReady: false
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
